import { render } from "./ProjectTile.vue?vue&type=template&id=06ae1312&scoped=true"
import script from "./ProjectTile.vue?vue&type=script&lang=js"
export * from "./ProjectTile.vue?vue&type=script&lang=js"

import "./ProjectTile.vue?vue&type=style&index=0&id=06ae1312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ae1312"]])

export default __exports__